import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../generic/CustomBtn';
import AssignAgentPopUp from '../../../../components/PopUp/AssignFieldAgent';
import { requestApi } from '../../../../utils/api-request';

const ResendInviteIcon = ({ data, isDisabledAction = false }) => {
  const translate = useIntl();
  const [resendIcon, setResendIcon] = useState(false);
  const resendInvite = async (id) => {
    await requestApi('PUT', '/api/dashboard/field-agent/invite', { field_agent_id: id });
  };

  return (
    <CustomBtn
      label={translate.formatMessage({ id: 'fieldAgents.resendInvite' })}
      customClass="btn__fa-action"
      iconClass={!resendIcon ? 'icon-reload' : 'icon-check-circle'}
      disabled={isDisabledAction || resendIcon}
      handleClick={() => {
        resendInvite(data.field_agent_id);
        setResendIcon(!resendIcon);
      }}
    />
  );
};

const ProjectSampleZone = ({ data, projectId, isDisabledAction = false, setDeleteInfo,
  setDeleteAgentPopUp, deleteAgentPopUp }) => {
  const translate = useIntl();
  const [assignAgentPopUp, setAssignAgentPopUp] = useState(false);
  const [simpleZoneInfo, setSimpleZoneInfo] = useState({});

  return (
    <div className="sample-zone__item">
      <span className="sample-zone__name">{data.sampleName}</span>
      {data.assign && (
        <>
          <span className="sample-zone__agent">{data.field_agent_name}</span>
          <span className="sample-zone__email">{data.field_agent_email}</span>
        </>
      )}
      <div className="sample-zone__action">
        {data.assign ? (
          <>
            <ResendInviteIcon data={data} isDisabledAction={isDisabledAction} />
            <CustomBtn
              label={translate.formatMessage({ id: 'fieldAgents.changeFA' })}
              iconClass="icon-pencil-alt"
              customClass="btn__fa-action"
              disabled={isDisabledAction}
              handleClick={() => {
                setSimpleZoneInfo({
                  projects: {
                    [projectId]: [
                      {
                        sample_zone_id: data.id,
                        sample_zone_name: data.sampleName,
                      },
                    ],
                  },
                });
                setAssignAgentPopUp(!assignAgentPopUp);
              }}
            />
            <CustomBtn
              customClass="fa-del-cta"
              iconClass="icon-trash"
              disabled={isDisabledAction}
              handleClick={() => {
                setDeleteInfo({
                  idProject: data.project_id,
                  sample_zone_id: data.id,
                  all: false,

                });
                setDeleteAgentPopUp(!deleteAgentPopUp);
              }}
            />
          </>
        ) : (
          <CustomBtn
            label={translate.formatMessage({ id: 'fieldAgents.assignFA' })}
            iconClass="icon-add"
            customClass="btn__fa-action"
            disabled={isDisabledAction}
            handleClick={() => {
              setSimpleZoneInfo({
                projects: {
                  [projectId]: [
                    {
                      sample_zone_id: data.id,
                      sample_zone_name: data.sampleName,
                    },
                  ],
                },
              });
              setAssignAgentPopUp(!assignAgentPopUp);
            }}
          />
        )}
        {assignAgentPopUp ? (
          <AssignAgentPopUp
            showPopUp={assignAgentPopUp}
            setShowPopUp={setAssignAgentPopUp}
            simpleZoneInfo={simpleZoneInfo}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ProjectSampleZone;
